/**
 * Blocos / torres no Cadastro do condomínio (0.1.90, Doc. Técnica §69).
 *
 * Controlado pela tela do condomínio (salva junto com o resto do cadastro). O síndico liga
 * "Este condomínio tem blocos ou torres?", escolhe o rótulo e lista nome + sigla. O bloco de
 * cada unidade sai do nome ("A-101" é do Bloco A) ou é escolhido na tabela de contatos.
 */
import { Plus, Trash2 } from "lucide-react";

export interface BlocoForm { id?: number; nome: string; sigla: string }
export interface BlocosForm { ativo: boolean; rotulo: "Bloco" | "Torre"; blocos: BlocoForm[] }
export const BLOCOS_VAZIO: BlocosForm = { ativo: false, rotulo: "Bloco", blocos: [] };

/** Sugestão de próximo bloco: A, B, C… (Bloco) ou 1, 2, 3… (Torre). */
function proximo(f: BlocosForm): BlocoForm {
  const n = f.blocos.length;
  const sigla = f.rotulo === "Torre" ? String(n + 1) : String.fromCharCode(65 + (n % 26));
  return { nome: `${f.rotulo} ${sigla}`, sigla };
}

export function BlocosCadastro({ valor: f, onChange }: { valor: BlocosForm; onChange: (f: BlocosForm) => void }) {
  const set = (p: Partial<BlocosForm>) => onChange({ ...f, ...p });
  const siglas = f.blocos.map((b) => b.sigla.trim().toUpperCase());
  const repetida = siglas.find((s, i) => s && siglas.indexOf(s) !== i);
  return (
    <div className="sm:col-span-2 rounded-lg border border-slate-200 bg-slate-50/60 p-2.5 space-y-2">
      <label className="flex items-center gap-2 text-[13px] text-slate-700">
        <input type="checkbox" checked={f.ativo}
          onChange={(e) => set({ ativo: e.target.checked, blocos: e.target.checked && !f.blocos.length ? [proximo(f)] : f.blocos })} />
        Este condomínio tem <b>blocos ou torres</b>
      </label>
      {f.ativo && (
        <>
          <div className="flex items-center gap-2 text-[12px] text-slate-600">
            Chamar de:
            {(["Bloco", "Torre"] as const).map((r) => (
              <button key={r} type="button" onClick={() => set({ rotulo: r })}
                className={`px-2.5 py-0.5 rounded-full border ${f.rotulo === r ? "bg-brand-700 text-white border-brand-700" : "bg-white border-slate-300"}`}>
                {r}
              </button>
            ))}
          </div>
          <div className="space-y-1">
            {f.blocos.map((b, i) => (
              <div key={i} className="flex items-center gap-1.5">
                <input value={b.nome} placeholder={`Nome (ex.: ${f.rotulo} A)`}
                  onChange={(e) => set({ blocos: f.blocos.map((x, j) => j === i ? { ...x, nome: e.target.value } : x) })}
                  className="flex-1 px-2 py-1 border border-slate-300 rounded text-sm" />
                <input value={b.sigla} placeholder="Sigla" maxLength={8}
                  onChange={(e) => set({ blocos: f.blocos.map((x, j) => j === i ? { ...x, sigla: e.target.value.toUpperCase() } : x) })}
                  className="w-20 px-2 py-1 border border-slate-300 rounded text-sm font-mono" title="Usada no nome da unidade: A-101" />
                <button type="button" onClick={() => set({ blocos: f.blocos.filter((_, j) => j !== i) })}
                  className="text-slate-400 hover:text-rose-600" title="Remover"><Trash2 size={14} /></button>
              </div>
            ))}
          </div>
          <button type="button" onClick={() => set({ blocos: [...f.blocos, proximo(f)] })}
            className="text-[12px] text-brand-700 inline-flex items-center gap-1"><Plus size={13} /> adicionar {f.rotulo.toLowerCase()}</button>
          {repetida && <p className="text-[11px] text-rose-600">A sigla "{repetida}" está repetida.</p>}
          <p className="text-[11px] text-slate-500">
            {f.rotulo === "Torre" ? (
              <>Dê às unidades nomes com a sigla na frente (<b className="font-mono">1-101</b>, <b className="font-mono">2-204</b>):
              o app reconhece a torre sozinho. Use o gerador abaixo com "repetir para cada torre", ou escolha a torre
              de cada unidade na tabela de contatos. Com isso, avisos e manutenções podem ir só para uma torre.</>
            ) : (
              <>Dê às unidades nomes com a sigla na frente (<b className="font-mono">A-101</b>, <b className="font-mono">B-204</b>):
              o app reconhece o bloco sozinho. Use o gerador abaixo com "repetir para cada bloco", ou escolha o bloco
              de cada unidade na tabela de contatos. Com isso, avisos e manutenções podem ir só para um bloco.</>
            )}
          </p>
        </>
      )}
    </div>
  );
}
